import axios from 'axios'
import Store from '../store'
import clearLoginData from '../Utils/clearLoginData'
export const authServiceBaseUrl = 'https://mswservices.gov.bd/mosw-auth-service/'
export const commonServiceBaseUrl = 'https://mswservices.gov.bd/mosw-common-service/'
export const productionServiceBaseUrl = 'https://mswservices.gov.bd/mosw-production-service/'
export const hospitalServiceBaseUrl = 'https://mswservices.gov.bd/mosw-hospital-service/'
export const childServiceBaseUrl = 'https://mswservices.gov.bd/mosw-child-service/'
export const grantAllowanceServiceBaseUrl = 'https://mswservices.gov.bd/mosw-grant-allowance-service/'
export const disabilitySchoolServiceBaseUrl = 'https://mswservices.gov.bd/mosw-disability-school-service/'
export const awarenessEventServiceBaseUrl = 'https://mswservices.gov.bd/mosw-awareness-event-service/'
export const socialWelfareServiceBaseUrl = 'https://mswservices.gov.bd/mosw-social-welfare-service/'
export const trainingElearningServiceBaseUrl = 'https://mswservices.gov.bd/mosw-training-elearning-service/'
export const socialStreetChildrenServiceBaseUrl = 'https://mswservices.gov.bd/mosw-social-street-children-service/'

// Handling server error
const errorHandler = (error) => {
  if (error.response.status === 401) {
    // session is over: remove everything the login left (incl. the persisted active role)
    clearLoginData()
    // window.vm.$toast.error({
    //   title: 'Error',
    //   message: 'Unauthorized access. '
    // })
    window.vm.$router.push('/auth/login')
  } else if (error.response.status === 500) {
    Store.commit('mutateCommonProperties', {
      loading: false,
      listReload: false
    })
    // window.vm.$router.push('/auth/error')
    // window.vm.$toast.error({
    //   title: 'Error',
    //   message: 'Server Error'
    // })
  } else if (error.response.status !== 422) {
    window.vm.$toast.error({
      title: 'Error',
      message: 'Operation failed due to an unknown error.'
    })
  }
  return error
}
// Current page + active role (picked on role select / switch role), for the backend's
// menu-wise permission check. Sent inside accessMenuName, which every service's CORS
// already allows; the backends' menu_name() log helper strips the "|role=" part.
const menuHeader = () => {
  // Only office staff (user_type 0) have a role. A citizen could carry a stale role left over from an
  // earlier staff session in the same browser.
  const authUser = Store.state.Auth && Store.state.Auth.authUser
  if (!authUser || authUser.user_type !== 0) {
    return window.location.href
  }
  const roleId = (Store.state.Auth && Store.state.Auth.activeRoleId) || parseInt(localStorage.getItem('accessUserRole')) || 0
  return roleId > 0 ? `${window.location.href}|role=${roleId}` : window.location.href
}

// Dedupe concurrent refresh attempts: several calls can 401 at the same time,
// they should all await the same in-flight refresh instead of racing it.
let refreshPromise = null

export const refreshAccessToken = () => {
  if (!refreshPromise) {
    const refreshToken = localStorage.getItem('refresh_token')
    if (!refreshToken) {
      return Promise.reject(new Error('No refresh token available'))
    }
    // Tells the server whether we still have our own access token. If we
    // don't (e.g. localStorage got partially cleared) but the underlying
    // token is still well within its life, the server would otherwise say
    // "success" without actually giving us anything to use - this flag
    // makes it reissue a real one instead.
    const hasAccessToken = !!localStorage.getItem('access_token')
    refreshPromise = axios.post(`${authServiceBaseUrl}v1/oauth/refresh`, { refresh_token: refreshToken, has_access_token: hasAccessToken })
      .then(response => {
        if (!response.data || !response.data.success) {
          throw new Error('Refresh failed')
        }
        // The access token is only reissued once it's close to expiring - most
        // refresh calls just rotate the refresh token and keep the existing one.
        if (response.data.access_token) {
          localStorage.setItem('access_token', response.data.access_token)
        }
        localStorage.setItem('refresh_token', response.data.refresh_token)
        localStorage.setItem('expires_in', response.data.expires_in)
        return localStorage.getItem('access_token')
      })
      .finally(() => { refreshPromise = null })
  }
  return refreshPromise
}

export default {
  async execute (baseUrl, method, uri, data, params = {}, isPdf = false, _retried = false) {
    const isRefreshCall = baseUrl === authServiceBaseUrl && typeof uri === 'string' && uri.indexOf('oauth/refresh') !== -1

    // If a refresh is already in flight (triggered by the heartbeat, or by
    // another call that 401'd first), wait for it instead of racing ahead
    // with a token that's already known to be getting replaced - otherwise
    // this call predictably 401s too, only to retry a moment later anyway.
    if (refreshPromise && !isRefreshCall) {
      try {
        await refreshPromise
      } catch (e) {
        // Ignore - if the refresh genuinely failed, this call proceeds with
        // whatever token exists and falls through to the normal 401-retry
        // handling below.
      }
    }

    const accessToken = localStorage.getItem('access_token')
    const userDetail = localStorage.getItem('userDetail')
    const client = axios.create({
      baseURL: baseUrl,
      json: true
    })
    // const user = localStorage.getItem('user')
    return client({
      method,
      url: uri,
      data,
      params: params,
      responseType: isPdf ? 'arraybuffer' : 'json',
      headers: {
        Authorization: accessToken ? `Bearer ${accessToken}` : '',
        // accessUsername: localStorage.getItem('accessUsername'),
        // accessUserId: localStorage.getItem('accessUserId'),
        // accessUserRole: localStorage.getItem('accessUserRole'),
        userDetail: userDetail ? `${userDetail}` : '',
        // accessOfficeId: user ? JSON.parse(user).office_id : '',
        accessMenuName: menuHeader()
      }
    }).then(req => {
      return req.data
    }).catch(async error => {
      const status = error.response && error.response.status

      if (status === 401 && !_retried && !isRefreshCall && localStorage.getItem('refresh_token')) {
        try {
          await refreshAccessToken()
          return this.execute(baseUrl, method, uri, data, params, isPdf, true)
        } catch (refreshError) {
          errorHandler(error)
          return error.response
        }
      }

      errorHandler(error)
      return error.response
    })
  },
  getData (baseUrl, uri, params = {}) {
    return this.execute(baseUrl, 'get', uri, {}, params)
  },
  getPdfData (baseUrl, uri, params = {}) {
    // const filters = setFilters()
    return this.execute(baseUrl, 'get', uri, {}, params, true)
  },
  postData (baseUrl, uri, data) {
    return this.execute(baseUrl, 'post', uri, data)
  },
  putData (baseUrl, uri, data) {
    return this.execute(baseUrl, 'put', uri, data)
  },
  deleteData (baseUrl, uri, params = {}) {
    return this.execute(baseUrl, 'delete', uri, params)
  }
}
